import * as tslib_1 from "tslib";
import React, { useState, useEffect, useMemo } from 'react';
import styled from '@/shared/styled';
import { Card, Tree, Empty, Button, Popconfirm, message, Switch, Icon } from 'antd';
import { dispatch } from '@@/store';
import { connect } from '@souche-f2e/muji';
import createModal from '@/shared/create-modal';
import { updateNotify } from '@/services/menu';
import AddMenuModal from './_components/AddMenuModal';
import SortMenuList from './_components/SortMenuList';
import EditNewFeatureNoticeModal from './_components/EditNewFeatureNoticeModal';
const mapStateToProps = (state) => {
    const { menu: { rawData }, } = state;
    return { rawData };
};
const MENU_LIST_OPTION = {
    0: '一级菜单',
    1: '二级菜单',
    2: '三级菜单',
};
const Root = styled(Card) `
  .dashboard {
    display: flex;
    min-width: 800px;
    margin: 24px;
    > .dashboard-sider {
      width: 264px;
      flex: 0 0 264px;
      .ant-card-body {
        padding: 12px;
      }
      .ant-card-body::-webkit-scrollbar {
        width: 0 !important;
      }
      .ant-menu-inline {
        border: none;
      }
      .ant-menu-submenu-arrow {
        display: none;
      }
    }
    > .dashboard-main {
      width: 0;
      flex: 1 1 0;
      margin-left: 16px;
      .ant-btn {
        margin-right: 5px;
      }
    }
    .btn-link{
      color: #1890ff;
      cursor: pointer;
      margin-left: 20px;
    }
  }
`;
const DeployMenu = ({ className, style, rawData, }) => {
    const [selectedMenu, setSelectedMenu] = useState(null);
    const menu = useMemo(() => {
        return [
            {
                name: 'root',
                title: 'root',
                path: '',
                id: 0,
                type: -1,
                children: rawData,
            },
        ];
    }, [rawData]);
    const [expandedKeys, setExpandedKeys] = useState([
        JSON.stringify({
            name: 'root',
            title: 'root',
            path: '',
            id: 0,
            type: -1,
            children: rawData,
        }),
    ]);
    useEffect(() => {
        setExpandedKeys([
            JSON.stringify({
                name: 'root',
                title: 'root',
                path: '',
                id: 0,
                type: -1,
                children: rawData,
            }),
        ]);
    }, [rawData]);
    const renderTreeNodes = (data) => {
        return data.map((item) => {
            if (item.children) {
                return (<Tree.TreeNode title={item.name} key={JSON.stringify(item)}>
            {renderTreeNodes(item.children)}
          </Tree.TreeNode>);
            }
            return <Tree.TreeNode title={item.name} key={JSON.stringify(item)}/>;
        });
    };
    const handleOnAddMenu = () => {
        createModal({
            title: '添加菜单项',
            width: '50%',
            content: <AddMenuModal {...{ initialValue: selectedMenu }}/>,
            onOk: (values) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield dispatch.menu.addOneMenu(values);
                setSelectedMenu(null);
                message.success('添加成功');
            }),
        });
    };
    const handleOnDelMenu = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        yield dispatch.menu.delOneMenu({ id: String(selectedMenu.id) });
        setSelectedMenu(null);
        message.success('删除成功');
    });
    const handleOnEditMenu = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        createModal({
            title: '编辑菜单项',
            width: '50%',
            content: (<AddMenuModal {...{ initialValue: selectedMenu, isEditMode: true }}/>),
            onOk: (values) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                const payload = Object.assign({}, values, { id: selectedMenu.id });
                yield dispatch.menu.updateOneMenu(payload);
                setSelectedMenu(null);
                message.success('编辑成功');
            }),
        });
    });
    const handleOnSortMenu = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        createModal({
            title: '排序子菜单项',
            content: <SortMenuList {...{ initialValue: selectedMenu }}/>,
            width: '50%',
            onOk: (values) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield Promise.all(values.children.map(c => {
                    const payload = {
                        sequence: c.sequence,
                        id: c.id,
                    };
                    return dispatch.menu.updateSequence(payload);
                }));
                setSelectedMenu(null);
                message.success('排序成功');
                yield dispatch.menu.loadMenuList();
            }),
        });
    });
    const handleEditNewNotice = () => {
        createModal({
            title: '编辑新功能提醒',
            content: <EditNewFeatureNoticeModal {...{ initialValue: selectedMenu }}/>,
            width: '60%',
            onOk: (values) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (!selectedMenu)
                    return;
                const submitData = Object.assign({}, values, { platformId: selectedMenu.id });
                yield updateNotify(submitData).promise;
                setSelectedMenu(null);
                message.success('修改新功能提醒成功！');
                yield dispatch.menu.loadMenuList();
            })
        });
    };
    return (<Root className={className} style={style} size="small">
      <div className="dashboard">
        <div className="dashboard-sider">
          <Card title="目录" size="small">
            <Tree expandedKeys={expandedKeys} onSelect={(selectedKeys) => {
        if (selectedKeys.length !== 0) {
            setSelectedMenu(JSON.parse(selectedKeys[0]));
        }
        else {
            setSelectedMenu(null);
        }
    }} onExpand={(expandedKeys) => {
        setExpandedKeys(expandedKeys);
    }}>
              {renderTreeNodes(menu)}
            </Tree>
          </Card>
        </div>
        <div className="dashboard-main">
          <Card size="small">
            {selectedMenu ? (<>
                {selectedMenu.path.includes('http') && (<p style={{ fontWeight: 500 }}>
                    注意：点击此类型链接会离开工程效率平台
                  </p>)}
                <p>菜单名称：{selectedMenu.name}</p>
                <p>
                  菜单类型：
                  {MENU_LIST_OPTION[selectedMenu.type] || '-'}
                </p>
                <p>对应前端路由：{selectedMenu.path || '-'}</p>
                <p>埋点：{selectedMenu.buried || '-'}</p>
                <p>链接地址：{selectedMenu.url || '-'}</p>
                <p>统一工作台资源code：{selectedMenu.resourceCode || '-'}</p>
                <p>
                  新功能提醒是否生效：
                  <Switch checkedChildren="开" unCheckedChildren="关" disabled checked={selectedMenu.notifyRedPoint} style={{ color: 'green' }}/>
                  <span className="btn-link" onClick={handleEditNewNotice}><Icon type="edit"/>编辑</span>
                </p>
                {selectedMenu.children && (<Button icon="ordered-list" onClick={handleOnSortMenu}>
                    排序子菜单
                  </Button>)}
                
                {selectedMenu.id !== 0 ? (<>
                    {!selectedMenu.url && (<Button onClick={handleOnAddMenu} icon="plus">
                        在当前菜单下添加
                      </Button>)}
                    <Button onClick={handleOnEditMenu} icon="edit">
                      修改当前条目
                    </Button>
                    <Popconfirm title="确定删除该条目？该操作不可逆！" okText="确定" cancelText="取消" onConfirm={handleOnDelMenu}>
                      <Button type="danger" icon="delete">
                        删除当前条目
                      </Button>
                    </Popconfirm>
                  </>) : (<Button onClick={handleOnAddMenu} icon="plus">
                    在当前菜单下添加
                  </Button>)}
              </>) : (<Empty description="请在左边选择某一菜单进行配置"/>)}
          </Card>
        </div>
      </div>
    </Root>);
};
export default connect(mapStateToProps)(DeployMenu);
